import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentRibbonComponent } from './environment-ribbon/environment-ribbon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EnvironmentRibbonComponent],
  exports: [EnvironmentRibbonComponent]
})
export class SharedUiEnvironmentRibbonModule {}
